"use client";
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Icon } from '../../Icon/Icon.web.js';

var _excluded = ["color", "size"];
var IconChp = function IconChp(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === undefined ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    sizeProp = _ref$size === undefined ? '48px' : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  var size = sizeProp;
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
    fill: "none",
    viewBox: "0 0 48 48",
    width: size,
    height: size
  }, /*#__PURE__*/React.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "M22 2.97v7h-2v-7zm-4 3v4h-2v-4zm20.207 5.237-1.414-1.414-5.945 5.944a3.9 3.9 0 0 0-.968-1.617 3.84 3.84 0 0 0-2.72-1.125L27 13l-.16-.004a3.84 3.84 0 0 0-2.84 1.25l-.12-.125a3.84 3.84 0 0 0-2.72-1.125L21 13l-.16-.004a3.84 3.84 0 0 0-2.84 1.25l-.12-.125a3.84 3.84 0 0 0-2.72-1.125L15 13l-.16-.004a3.84 3.84 0 0 0-3.838 4.063L11 35.586l-4.677 4.677 1.414 1.414zM25 17v4.586l4-4.001.002-.643a1.84 1.84 0 0 0-1.77-1.946l-.29.002a1.837 1.837 0 0 0-1.937 1.692l.001.088zm-1.999 1.692v4.894l-4.001 4V17l.006-.222-.001-.088a1.837 1.837 0 0 1 1.937-1.692l.29-.002a1.84 1.84 0 0 1 1.766 1.685q-.008.187.004.377zM17 29.586l.001-10.43v-2.098a4 4 0 0 1-.003-.377 1.84 1.84 0 0 0-1.766-1.685l-.29.002a1.84 1.84 0 0 0-1.408.536c-.33.33-.52.772-.536 1.275L13 17v16.586zm17.63-7.266c-5.71 0-10.34 4.63-10.34 10.34S28.92 43 34.63 43s10.34-4.63 10.34-10.34-4.63-10.34-10.34-10.34m0 2a8.34 8.34 0 1 1 0 16.68 8.34 8.34 0 0 1 0-16.68M11 18.97v2H6v-2zm15-9v-4h-2v4zm5.95 23.43 3.58-7.17v5.38h1.8l-3.59 7.17V33.4z",
    clipRule: "evenodd"
  })));
};

export { IconChp, IconChp as default };
